import React from 'react';
import Layout from '../../components/Layout/Layout';
import BookingContainer from './BookingContainer';
import SubNavBar from '../../components/SubNavBar/SubNavBar';


async function action({ params, store, query }) {
    const title = store.getState().siteSettings?.data?.siteTitle
    const description = store.getState().siteSettings?.data?.metaDescription;
    const id = Number(params?.id);

    let isAuthenticated = store.getState().runtime.isAuthenticated;

    if (!isAuthenticated) {
        return { redirect: '/' }
    }

    return {
        title,
        description,
        component: (
            <Layout>
                <div className={isAuthenticated ? "subPageMainContainer" : "withoutPageMainContainer"}>
                    {isAuthenticated && <SubNavBar />}
                    <BookingContainer id={id} />
                </div>
            </Layout>
        ),
    };
}

export default action;